<!-- 文件中文名: 经销商注册成功(印度专属) -->
<template>
  <div class="register-success app-container">
    <app-breadcrumb/>
    <div class="page-container recharge-manage">
      <p>{{ $t('info.register.success') }}</p>
      <p style="height: 24px;line-height: 24px">{{ $t('miMember.memberNo') }}: <span style="font-weight: 700;color: red">{{ memberNo }}</span></p>
      <el-divider />
      <div style="text-align: center">
        <!--现在登录-->
<!--        <el-button type="primary" icon="el-icon-right" @click="goLogin">{{ $t('info.login.now') }}</el-button>-->
      </div>
    </div>
  </div>
</template>

<script>

import {getLanguage} from "@/lang"

export default {
  name: 'RegisterSuccess',
  directives: {},
  components: {},
  data() {
    return {
      memberNo: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {
  },
  async created() {
    this.$route.query.memberNo ? this.memberNo = this.$route.query.memberNo : await this.$router.push({path: '/login'})
    // this.$i18n.locale = this.$route.query.language.toString()
    await getLanguage()
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    goLogin() {
      this.$router.push({path: '/login'})
    }
  }
}

</script>

<style scoped>

</style>
